<template>
  <b-container fluid style="max-width:1200px;">
    <b-row style="margin-top: 4em">
      <b-col>
        <h2 class="text-info">{{ $t("globals.all_permissions") }}</h2>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="my-3">
        <b-input-group>
          <b-form-input
            v-model="filter"
            :placeholder="$t('globals.type_to_search')"
          />
          <b-input-group-append>
            <b-btn variant="warning" :disabled="!filter" @click="filter = ''">
              {{ $t("globals.clear") }}
            </b-btn>
          </b-input-group-append>
        </b-input-group>
      </b-col>
      <b-col cols="2" class="my-3">
        <b-form-select v-model="perPage" :options="perPageOptions" />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-table
          hover
          small
          primary-key="id"
          :filter="filter"
          :current-page="currentPage"
          :per-page="perPage"
          :items="items"
          :fields="fields"
          @row-clicked="rowClicked"
          @filtered="onFiltered"
        >
          <template v-slot:cell(brands)="row">
            <b-row>
              <b-col>
                <img
                  v-if="
                    row.item.permissions.filter(
                      permission => permission.brand == 'ulubv'
                    ).length > 0
                  "
                  class="img-thumbnail, logo"
                  src="@/assets/ulubv_logo.png"
                  alt="ULU BV logo"
                />
              </b-col>
              <b-col>
                <img
                  v-if="
                    row.item.permissions.filter(
                      permission => permission.brand == 'ulu'
                    ).length > 0
                  "
                  class="img-thumbnail, logo"
                  src="@/assets/uluLogo.png"
                  alt="ULU logo"
                />
              </b-col>
              <b-col>
                <img
                  v-if="
                    row.item.permissions.filter(
                      permission => permission.brand == 'fleetify'
                    ).length > 0
                  "
                  class="img-thumbnail, logo"
                  src="@/assets/fleetifyLogo.png"
                  alt="Fleetify logo"
                />
              </b-col>
              <b-col>
                <img
                  v-if="
                    row.item.permissions.filter(
                      permission => permission.brand == 'uluuk'
                    ).length > 0
                  "
                  class="img-thumbnail, logo"
                  src="@/assets/uluuk_logo.png"
                  alt="Fleetify logo"
                />
              </b-col>
              <b-col>
                <img
                  v-if="
                    row.item.permissions.filter(
                      permission => permission.brand == 'cartracker'
                    ).length > 0
                  "
                  class="img-thumbnail, logo"
                  src="@/assets/cartrackerLogo.png"
                  alt="Cartracker logo"
                />
              </b-col>
              <b-col>
                <img
                  v-if="
                    row.item.permissions.filter(
                      permission => permission.brand == 'traksi'
                    ).length > 0
                  "
                  class="img-thumbnail, logo"
                  src="@/assets/traksi_logo.png"
                  alt="Traksi logo"
                />
              </b-col>
              <b-col>
                <img
                  v-if="
                    row.item.permissions.filter(
                      permission => permission.brand == 'requre'
                    ).length > 0
                  "
                  class="img-thumbnail, logo"
                  src="@/assets/requre_logo.png"
                  alt="Requre logo"
                />
              </b-col>
              <b-col>
                <img
                  v-if="
                    row.item.permissions.filter(
                      permission => permission.brand == 'finnik'
                    ).length > 0
                  "
                  class="img-thumbnail, logo"
                  src="@/assets/finnik_logo.png"
                  alt="finnik logo"
                />
              </b-col>
              <b-col>
                <img
                  v-if="
                    row.item.permissions.filter(
                      permission => permission.brand == 'national_netherlands'
                    ).length > 0
                  "
                  class="img-thumbnail, logo"
                  src="@/assets/ohra_logo.png"
                  alt="national netherlands logo"
                />
              </b-col>
              <b-col>
                <img
                  v-if="
                    row.item.permissions.filter(
                      permission => permission.brand == 'imoto'
                    ).length > 0
                  "
                  class="img-thumbnail, logo"
                  src="@/assets/imoto_logo.png"
                  alt="imoto logo"
                />
              </b-col>
            </b-row>
          </template>
        </b-table>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="my-1">
        <b-pagination
          :total-rows="items.length"
          :per-page="perPage"
          v-model="currentPage"
        />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";

export default {
  data() {
    return {
      filter: null,
      currentPage: 1,
      perPage: 20,
      perPageOptions: [
        { text: "20 " + this.$t("globals.per_page"), value: 20 },
        { text: "40 " + this.$t("globals.per_page"), value: 40 },
        { text: "60 " + this.$t("globals.per_page"), value: 60 }
      ],
      fields: [
        {
          key: "name",
          label: this.$t("globals.name"),
          sortable: true
        },
        {
          key: "email",
          label: this.$t("globals.email"),
          sortable: true
        },
        {
          key: "brands",
          label: this.$t("globals.brands"),
          sortable: false
        }
      ],
      items: []
    };
  },
  computed: {
    ...mapGetters(["getUserBrandPermissions"])
  },
  methods: {
    ...mapActions("axios_mod", ["simpleFetch"]),
    ...mapMutations(["setShowLoadingModal"]),
    rowClicked(item) {
      this.$router.push({ name: "editpermissions", params: { id: item.id } });
    },
    onFiltered() {
      this.currentPage = 1;
    },
    fetchAllUsers() {
      const data = {
        query: `
          query {
            allAuthenticatedUsers {
              id
              firstname
              lastname
              email
              user_permissions {
                brand
              }
            }
          }
        `
      };

      this.setShowLoadingModal(true);
      this.simpleFetch({data, this_ref: this}).then((res) => {
        if (res) {
          this.items = res.allAuthenticatedUsers.map(user => {
            return {
              id: user.id,
              name: `${user.firstname} ${user.lastname}`,
              email: user.email,
              permissions: user.user_permissions
            };
          });
        }
      }).finally(()=>{
        this.setShowLoadingModal(false)
      });
    }
  },
  mounted() {
    this.fetchAllUsers();
  },
  created() {
    if (!this.getUserBrandPermissions.permissions_index) {
      this.$router.push({ name: "dashboard" });
    }
  }
};
</script>

<style scoped>
.logo {
  height: 1.5em;
}
</style>
